<template>
  <div>
    <mdb-modal @shown="componentDidMount" :show="visible" @close="closeModal">
      <mdb-modal-header>
        <mdb-modal-title>Import from Merchant</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
          <mdb-container>
            <mdb-row class="mb-3">
                <mdb-col col="12">
                    <select v-model="selected_merchant" class="browser-default custom-select">
                        <option value="" disabled>Select Merchant</option>
                        <option :value="merchant" v-bind:key="merchant.id" v-for="merchant in merchants">{{merchant.name}}</option>
                    </select>
                </mdb-col>
            </mdb-row>
            <mdb-row v-bind:key="category.id" v-for="category in categories">
                <mdb-col col="12">
                    <div class="custom-control custom-checkbox">
                        <input @click="selectCategory(category)" type="checkbox" class="custom-control-input" :id="category.id">
                        <label class="custom-control-label" :for="category.id">{{category.name}}</label>
                    </div>
                </mdb-col>
            </mdb-row>
          </mdb-container>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="loading" />
        <mdb-btn v-if="!loading" @click="submitImport" color="primary">Import</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbContainer, mdbRow, mdbCol,
  mdbSpinner} from 'mdbvue';
  import { ajax } from '../js/ajax';

  export default {
    components: {
      mdbModal, mdbSpinner,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,mdbContainer, mdbRow, mdbCol
    },
    
    props: ['visible', 'close', 'target_merchant', 'callback'],
    data: ()=>({
        loading:false,
        merchants: [],
        selected_merchant: null,
        categories: [],
        selected_categories: [],
    }),
    methods: {
        closeModal(){
            this.selected_merchant=null;
            this.close();
        },
        submitImport(){
            if(this.selected_categories.length==0){
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/import_categories_products",
                data: {merchant_id: this.selected_merchant.id, categories: this.selected_categories, target_merchant_id: this.target_merchant.id},
                success: ()=>{
                    this.callback();
                    this.closeModal();
                   this.$notify.success({message: 'Owh Wow Categories and Product had been copied successfully! =P', position:'top right', timeOut: 5000});
                },
                complete: ()=>this.loading=false
            })
        },
        checkSelect(category){
            let found_index= this.selected_categories.findIndex(element=>{
                return element==category.id;
            })
            return found_index>=0?true:false;
        },
        selectCategory(category){
            this.selected_categories.push(category.id);
        },
        componentDidMount(){
            this.loading=true;
            ajax({
                url: "admin/list_all_merchants",
                success: result=>{
                    this.merchants=result.data;
                },
                complete: ()=>this.loading=false
            })
        }
    },
    watch: {
        selected_merchant(){
            this.categories=[];
            this.selected_categories=[];
            if(!this.selected_merchant){
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/get_merchant_categories",
                data: {id:this.selected_merchant.id}, 
                success: result=>{
                    this.categories=result.data;
                },
                complete: ()=>this.loading=false
            })
        }
    }
  };
</script>